import { takeEvery } from 'redux-saga/effects';
import { StartApplication } from '@signageos/actions/dist/Application/applicationActions';
import { AuthenticationSucceed } from '@signageos/actions/dist/Authentication/authenticationActions';
import { notifyCurrentTime } from '../../../Device/DateTime/currentTimeSyncSagas';

export function* startupDeviceDateTimeSettings() {
	yield takeEvery(StartApplication, notifyCurrentTime);
	yield takeEvery(AuthenticationSucceed, notifyCurrentTime);
}
